import { Breakpoints, styled } from '@vw-marketing/us-components';

interface ImageProps {
  readonly url: string;
}

export const StyledThumbnailWrapper = styled.div<ImageProps>`
  display: flex;
  padding-right: 10px;

  width: 100%;

  @media (min-width: ${Breakpoints.b960}px) {
    padding-right: 16px;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    padding-right: 50px;
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    padding-right: 80px;
  }
  * {
    cursor: pointer;
  }
`;

export const StyledThumbnail = styled.div`
  padding-right: 10px;
  width: 100%;

  img {
    border: 2px inset rgba(255, 255, 255, 0);
  }

  @media (min-width: 736px) {
    padding-right: 0;
  }
`;

export const StyledCaption = styled.div`
  * {
    font-size: 12px;
    line-height: 20px;
    padding: 3px 5px 0;

    @media (min-width: 736px) {
      font-size: 12px;
      line-height: 18px;
    }

    @media (min-width: ${Breakpoints.b1280}px) {
      font-size: 14px;
      line-height: 24px;
      padding: 3px 7px 0;
    }
  }
`;

export const StyledDisabledSlide = styled.div`
  pointer-events: none;
`;
